import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-secure',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './secure.component.html',
  styleUrl:'./secure.component.css'
})
export class SecureComponent {

}
